import { tryCatchMiddleware } from './tryCatchMiddleware';
import { crashHandler } from './crashEventHandler';

export const crashHandlerMiddleware = tryCatchMiddleware(crashHandler);
